import { PaginationData } from "../redux/types";

export const getPaginationDataFromResponse = (response: Response): PaginationData | null => {
    const headerContent = response.headers.get('x-Pagination');
    if (headerContent) {
        return JSON.parse(headerContent) as PaginationData;
    }
    return null;
}